import { useContext } from "react";
import ScrollContext from "context/ScrollContext";

function useScroll() {
  const context = useContext(ScrollContext);
  return context;
}

export default useScroll;
